import {UseQueryResult} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {GET_PINNED_GLOBAL_MEASUREMENT_NAME_KEY} from '../../api/queries/getPinnedGlobalMeasurementName'
import {DistributedCacheResponse} from '../../types/DistributedCache'

import {useSettingsQuery} from '@settings/modules/common/providers'

export function usePinnedGlobalMeasurementNameQuery(
  keyIdentifier: string
): UseQueryResult<DistributedCacheResponse> {
  const {t} = useTranslation()
  const isEnabled = keyIdentifier.length > 0 && !keyIdentifier.startsWith('undefined-')

  return useSettingsQuery(GET_PINNED_GLOBAL_MEASUREMENT_NAME_KEY, [keyIdentifier], {
    enabled: isEnabled,
    meta: {
      errorMessage: t('measurementsSettings.queryError', {
        entity: 'Pinned Global Measurement Names'
      })
    }
  })
}
